import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 95AA0ED2-4221-4123-B3BF-9FACF3702CA4
 * name pause-octagon-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pause-octagon-outline.svg
 * tags
 */
export const PauseOctagonOutlineIcon = createSvgIcon(<><path d="M15,16H13V8H15V16M11,16H9V8H11V16M15.73,3L21,8.27V15.73L15.73,21H8.27L3,15.73V8.27L8.27,3H15.73M14.9,5H9.1L5,9.1V14.9L9.1,19H14.9L19,14.9V9.1L14.9,5Z" /></>, 'PauseOctagonOutlineIcon');
export default PauseOctagonOutlineIcon